import { render, staticRenderFns } from "./registro-item.vue?vue&type=template&id=f0c36e7a&"
import script from "./registro-item.vue?vue&type=script&lang=js&"
export * from "./registro-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports